import React, { useContext } from 'react'
import { Box, Grid, Typography, Link, Divider, Stack } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import FacebookIcon from '@mui/icons-material/Facebook'
import InstagramIcon from '@mui/icons-material/Instagram'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import * as ROUTES from '../routes'
import { ContactContext } from '../contactContext'

const FOOTER_BG = '#0F2336'

export default function StickyFooter() {
    const socials = useContext(ContactContext).value

    return (
        <Box component='footer' sx={{ bgcolor: FOOTER_BG, color: '#E2E8F0', mt: 'auto' }}>
            {/* Main grid */}
            <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 3, sm: 5 }, pt: { xs: 5, md: 6 }, pb: 4 }}>
                <Grid container spacing={{ xs: 4, md: 5 }}>

                    {/* Column 1 — Brand + Socials */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant='overline' sx={{ color: 'rgba(255,255,255,0.5)', letterSpacing: '0.12em', mb: 1.5, display: 'block' }}>
                            Follow Us
                        </Typography>
                        <Stack spacing={1.25}>
                            <SocialLink href={socials.FB_LINK} icon={<FacebookIcon fontSize='small' />} label='Facebook' />
                            <SocialLink href={socials.IG_LINK} icon={<InstagramIcon fontSize='small' />} label='Instagram' />
                            {/* <SocialLink href={socials.LinkedIN_LINK} icon={<LinkedInIcon fontSize='small' />} label='LinkedIn' /> */}
                        </Stack>
                    </Grid>

                    {/* Column 2 — Navigation */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant='overline' sx={{ color: 'rgba(255,255,255,0.5)', letterSpacing: '0.12em', mb: 1.5, display: 'block' }}>
                            Explore
                        </Typography>
                        <Stack spacing={1}>
                            <FooterNavLink to={ROUTES.PROPERTIES} label='Browse Properties' />
                            <FooterNavLink to={ROUTES.RENTALS}     label='Rental Listings' />
                            <FooterNavLink to={ROUTES.LANDSCAPING} label='Landscaping Services' />
                            <FooterNavLink to={ROUTES.SELL}        label='Sell Your Property' />
                            <FooterNavLink to={ROUTES.ABOUT}       label='About Us' />
                            <FooterNavLink to={ROUTES.CONTACT}     label='Contact Us' />
                        </Stack>
                    </Grid>

                    {/* Column 3 — Contact */}
                    <Grid item xs={12} sm={6} md={4}>
                        <Typography variant='overline' sx={{ color: 'rgba(255,255,255,0.5)', letterSpacing: '0.12em', mb: 1.5, display: 'block' }}>
                            Contact
                        </Typography>
                        <Stack spacing={1.25}>
                            {socials.email && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <EmailIcon fontSize='small' sx={{ color: 'rgba(255,255,255,0.45)', flexShrink: 0 }} />
                                    <Typography variant='body2' sx={{ color: '#CBD5E0', wordBreak: 'break-all' }}>
                                        {socials.email}
                                    </Typography>
                                </Box>
                            )}
                            {socials.phone && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PhoneIcon fontSize='small' sx={{ color: 'rgba(255,255,255,0.45)', flexShrink: 0 }} />
                                    <Typography variant='body2' sx={{ color: '#CBD5E0' }}>
                                        {socials.phone}
                                    </Typography>
                                </Box>
                            )}
                            {socials.address && (
                                <Typography variant='body2' sx={{ color: '#CBD5E0', lineHeight: 1.6, mt: 0.5 }}>
                                    {socials.address}
                                </Typography>
                            )}
                        </Stack>
                    </Grid>


                </Grid>
            </Box>

            {/* Bottom bar */}
            <Divider sx={{ borderColor: 'rgba(255,255,255,0.08)' }} />
            <Box sx={{ maxWidth: 1200, mx: 'auto', px: { xs: 3, sm: 5 }, py: 2, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                <Typography variant='caption' sx={{ color: 'rgba(255,255,255,0.4)' }}>
                    © {new Date().getFullYear()}{' '}
                    <Link href='https://choicerealestateda.com' sx={{ color: 'rgba(255,255,255,0.6)', textDecorationColor: 'rgba(255,255,255,0.3)' }}>
                        Choice Real Estate
                    </Link>
                    . All rights reserved.
                </Typography>
                <Typography variant='caption' sx={{ color: 'rgba(255,255,255,0.3)' }}>
                    Dominica, West Indies
                </Typography>
            </Box>
        </Box>
    )
}

function SocialLink({ href, icon, label }) {
    if (!href) return null
    return (
        <Link href={href} target='_blank' rel='noopener noreferrer' underline='none'
            sx={{ display: 'flex', alignItems: 'center', gap: 1, color: '#A0AEC0', '&:hover': { color: '#fff' }, transition: 'color 0.15s' }}>
            {icon}
            <Typography variant='body2' sx={{ color: 'inherit' }}>{label}</Typography>
        </Link>
    )
}

function FooterNavLink({ to, label }) {
    return (
        <Link component={RouterLink} to={to} underline='none'
            sx={{ display: 'block', color: '#A0AEC0', fontSize: '0.875rem', '&:hover': { color: '#fff' }, transition: 'color 0.15s' }}>
            {label}
        </Link>
    )
}
